<script>
import {
  ProductionStatisticsServiceProxy,
  ProductionPlanTypeServiceProxy
} from '@/service-proxies/app-v2/coproduction.service-proxies'
import { FieldSettingServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import AdvanceSearch from '../compenents/AdvanceSearch'
import { scrappedReasonExport } from '@/api/api.ts'
import dayjs from 'dayjs'

const pssp = new ProductionStatisticsServiceProxy()
const productionPlanTypeServiceProxy = new ProductionPlanTypeServiceProxy()
const fssp = new FieldSettingServiceProxy()
export default {
  components: {
    AdvanceSearch
  },
  data () {
    return {
      dto: {
        endTime: '',
        planCode: '',
        reportName: '',
        scrappedReason: '',
        scrappedType: '',
        startTime: '',
        typeId: '',
        workStationName: ''
      },
      filter: {
        current: 1,
        size: 30
      },
      data: [],
      total: 0,
      planType: [],
      loading: false,
      scrollY: 600,
      advanceVisible: false,
      extraCols: []
    }
  },
  computed: {
    advanceForm () {
      return [
        { name: this.$t('page_qc_scrapped_time'), key: 'time', slot: 'date' },
        { name: this.$t('page_control_code'), key: 'planCode', slot: 'input' },
        {
          name: this.$t('page_work_order_execution_reporting_staff'),
          key: 'reportName',
          slot: 'input'
        },
        { name: this.$t('page_scrap_reason'), key: 'scrappedReason', slot: 'input' },
        { name: this.$t('page_scrap_type'), key: 'scrappedType', slot: 'input' },
        { name: this.$t('page_qc_product_workstaion'), key: 'workStationName', slot: 'input' }
      ]
    },
    columns () {
      return [
        {
          title: this.$t('page_scrap_type_code'),
          dataIndex: 'scrappedTypeCode',
          key: 'scrappedTypeCode',
          width: 120,
          ellipsis: true
        },
        {
          title: this.$t('page_scrap_type'),
          dataIndex: 'scrappedType',
          key: 'scrappedType',
          width: 120,
          ellipsis: true
        },
        {
          title: this.$t('page_scrap_reason'),
          dataIndex: 'scrappedReason',
          key: 'scrappedReason',
          width: 120,
          ellipsis: true
        },
        {
          title: this.$t('page_qc_scrapped_time'),
          dataIndex: 'scrappedTime',
          key: 'scrappedTime',
          width: 120,
          ellipsis: true,
          customRender: (text) => {
            if (text) {
              return dayjs(text).format('YYYY-MM-DD HH:mm:ss')
            }
          }
        },
        {
          title: this.$t('page_product_name'),
          dataIndex: 'productName',
          key: 'productName',
          width: 120,
          ellipsis: true
        },
        {
          title: this.$t('page_product_code'),
          dataIndex: 'productCode',
          key: 'productCode',
          width: 120,
          ellipsis: true
        },
        {
          title: this.$t('page_plan_scrap_number'),
          dataIndex: 'scrappedNumber',
          key: 'scrappedNumber',
          width: 120,
          ellipsis: true
        },
        {
          title: this.$t('page_plan_production_plan_no'),
          dataIndex: 'planCode',
          key: 'planCode',
          width: 120,
          ellipsis: true
        },
        {
          title: this.$t('page_plan_order_no'),
          dataIndex: 'orderCode',
          key: 'orderCode',
          width: 120,
          ellipsis: true
        },
        {
          title: this.$t('page_plan_craft_name'),
          dataIndex: 'processName',
          key: 'processName',
          width: 120,
          ellipsis: true
        },
        {
          title: this.$t('page_standard_process_procedure_code'),
          dataIndex: 'processCode',
          key: 'processCodeage',
          width: 120,
          ellipsis: true
        },
        {
          title: this.$t('page_work_order_execution_reporting_staff'),
          dataIndex: 'reportName',
          key: 'reportName',
          width: 120,
          ellipsis: true
        },
        {
          title: this.$t('page_qc_product_workstaion'),
          dataIndex: 'workStationName',
          key: 'workStationName',
          width: 120,
          ellipsis: true
        },
        ...this.extraCols
      ]
    }
  },
  created () {
    this.getExtraFields()
    productionPlanTypeServiceProxy.getProductionPlanTypeInfo().then((types) => {
      const value = types
      if (value && value.length) {
        this.planType = value
          .map((res) => {
            const id = res.id
            const value = {
              name: res.name,
              id: id
            }
            return value
          })
        console.log(this.planType)
        this.dto.typeId = this.planType[0].id
      }
      this.getList()
    })
  },
  methods: {
    // 获取用户自定义字段
    async getExtraFields () {
      let extraCols = []
      let res = await fssp.listFieldSettings('page_plan_report_work_order')
      res.map(item => {
        if (item.isDisplay) {
          extraCols.push({
            title: item.name,
            key: item.code,
            dataIndex: item.code,
            width: 120
          })
        }
      })
      this.extraCols = extraCols
    },
    async getList () {
      this.loading = true
      const res = await pssp.scrappedReasonSchedule(this.filter.current, this.filter.size, this.dto)
      // this.data = res.records

      let dataLength = res.records.length
      let copy = JSON.parse(JSON.stringify(res.records))
      let needPush = 0
      if (dataLength < 30) {
        needPush = 30 - dataLength
        for (var k = 0; k < needPush; k++) {
          let obj = {
            // id: 'none'
          }
          copy.push(obj)
        }
      }

      this.data = JSON.parse(JSON.stringify(copy))


      this.total = Number(res.total)
      this.loading = false
      this.$nextTick(() => {
        this.getHeight()
      })
    },
    getHeight () {
      const div = document.getElementById('error-content')
      this.scrollY = div.clientHeight - 68
      const topBody = document.querySelector('#error-content .ant-table-body')
      if (topBody) {
        topBody.style.maxHeight = div.clientHeight - 68 + 'px'
      }
    },
    showTotal (total) {
      return this.$t('Total…items').replace('{0}', total)
    },
    handleChange (value) {
      this.filter.current = 1
      this.dto.typeId = value
      this.getList()
    },
    handleTableChange (value) {
      this.filter.current = value
      this.getList()
    },
    onClose () {
      this.advanceVisible = false
    },
    openAdvance () {
      this.advanceVisible = !this.advanceVisible
    },
    onSearch (value) {
      Object.keys(value).forEach((key) => {
        if (key !== 'time') {
          this.dto[key] = value[key]
        } else if (key === 'time') {
          this.dto['startTime'] =
            value[key] && value[key].length
              ? dayjs(value[key][0]).format('YYYY-MM-DD HH:mm:ss')
              : ''
          this.dto['endTime'] =
            value[key] && value[key].length
              ? dayjs(value[key][1]).format('YYYY-MM-DD HH:mm:ss')
              : ''
        }
      })
      this.filter.current = 1
      this.getList()
    },
    async handleMenuClick ({ key }) {
      let params = {
        typeId: this.dto.typeId
      }// 全部导出
      let page = {
        current: 1,
        size: -1
      }

      if (key !== '1') { // 按筛选结果导出
        params = this.dto
        page = this.filter
      }

      let res = await scrappedReasonExport(params, page)
      // 创建隐藏的可下载链接
      var a = document.createElement('a')
      a.download = `${ this.$t('page_cause_error') }.xlsx`
      a.style.display = 'none'
      let url = URL.createObjectURL(res)
      a.href = url
      // 触发点击
      document.body.appendChild(a)
      a.click()
      // 然后移除
      URL.revokeObjectURL(url)
      document.body.removeChild(a)
    }
  }
}
</script>

<template>
  <div class="error-body">
    <div class="cause-error-top">
      <!--按全部导出/按筛选结果导出 -->
      <a-dropdown>
        <a-menu slot="overlay" @click="handleMenuClick">
          <a-menu-item key="1">{{ $t('page_product_confirm_all_export') }}</a-menu-item>
          <a-menu-item key="2">{{ $t('page_product_confirm_search_export') }}</a-menu-item>
        </a-menu>
        <a-button>
          {{ $t('page_product_export') }}
          <a-icon type="down"/>
        </a-button>
      </a-dropdown>
      <div>
        <a-select :value="dto.typeId" style="width: 120px" @change="handleChange">
          <template v-for="(type, index) in planType">
            <a-select-option :key="index" :value="type.id">
              {{ type.name }}
            </a-select-option>
          </template>
        </a-select>
        <a-button style="margin-left: 4px" @click="openAdvance()">{{
          $t('page_my_document_advanced')
          }}
        </a-button>
      </div>
    </div>
    <div class="error-content" id="error-content">
      <ml-table
              :columns="columns"
              :loading="loading"
              :data-source="data"
              :scroll="{ y: scrollY, x: 1680 }"
      >
      </ml-table>
      <a-pagination
              style="position:absolute;bottom: 4px;right: 20px"
              :show-total="(total) => `${showTotal(total)}`"
              :current="filter.current"
              :pageSize="filter.size"
              :total="total"
              @change="handleTableChange"
      />
    </div>
    <advance-search
            :visible="advanceVisible"
            :subTitle="`(${$t('page_scrap_reason')})`"
            @close="onClose()"
            @search="(value) => onSearch(value)"
            :form="advanceForm"
            :value="dto"
    ></advance-search>
  </div>
</template>

<style scoped>
  .cause-error-top {
    display: flex;
    align-content: center;
    justify-content: space-between;
    padding-bottom: 8px;
  }

  .error-body {
    height: 100%;
    /* overflow: hidden; */
    position: relative;
  }

  .error-content {
    height: calc(100% - 41px);
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
</style>
